export const usersColumns = ['Nome', 'Permissão', 'Último Acesso', 'Status'];
